import * as React from "react"
import { Head, Link } from "@inertiajs/react"
import { Plus, Sparkles } from "lucide-react"
import { AdminShell } from "@/components/AdminShell"
import { PageHeader } from "@/components/PageHeader"
import { DeckFormDialog } from "@/components/flashcards/DeckFormDialog"
import { QuizList } from "@/components/quizzes/QuizList"
import { Button } from "@/components/ui/button"
import type { ProgramOption } from "@/components/ProgramSelect"
import type { QuizSummary } from "@/types/quizzes"

export default function AdminQuizzesIndex({ quizzes, programs }: { quizzes: QuizSummary[]; programs: ProgramOption[] }) {
  const [creating, setCreating] = React.useState(false)

  return (
    <>
      <Head title="Official quizzes">
        <meta name="description" content="Create, edit, and publish the official multiple-choice quizzes every user can take." />
        <meta property="og:title" content="Official quizzes" />
        <meta property="og:description" content="Create, edit, and publish the official multiple-choice quizzes every user can take." />
      </Head>
      <AdminShell>
        <PageHeader
          title="Official quizzes"
          description="Quizzes every user can take. Drafts stay hidden until you publish them."
          actions={
            <>
              <Button type="button" variant="secondary" onClick={() => setCreating(true)}>
                <Plus className="h-4 w-4" /> New quiz
              </Button>
              <Button asChild>
                <Link href="/generations/new?kind=quiz&official=1">
                  <Sparkles className="h-4 w-4" /> Generate with AI
                </Link>
              </Button>
            </>
          }
        />

        <div className="mt-6">
          {quizzes.length === 0 ? (
            <div className="callout">
              <p>No official quizzes yet. Create one to start adding questions.</p>
            </div>
          ) : (
            <QuizList quizzes={quizzes} hrefFor={(quiz) => `/admin/quizzes/${quiz.id}`} showStatus />
          )}
        </div>

        <DeckFormDialog
          open={creating}
          onOpenChange={setCreating}
          action="/admin/quizzes"
          method="post"
          title="New official quiz"
          description="It starts as a draft. Publish it when the questions are ready."
          submitLabel="Create draft"
          programs={programs}
        />
      </AdminShell>
    </>
  )
}
